import { useId, useRef, type ReactNode } from 'react';

/** Keeps controls mounted when collapsed and records each section's expansion. */
export function StudioSection({ title, summary, open, onToggle, children }: {
  title: string; summary: string; open: boolean; onToggle: (open: boolean) => void; children: ReactNode;
}) {
  const id = useId();
  const content = useRef<HTMLDivElement>(null);
  return <section className="studio-section">
    <button type="button" className="studio-section-toggle" aria-expanded={open} aria-controls={id}
      onClick={() => onToggle(!open || !!content.current?.querySelector('[aria-invalid="true"]'))}>
      <strong>{title}</strong><span>{summary}</span><span aria-hidden="true">{open ? '−' : '+'}</span>
    </button>
    <div id={id} ref={content} hidden={!open} onInvalidCapture={() => onToggle(true)}>{children}</div>
  </section>;
}
